import { Flex, Spinner, SpinnerProps } from 'theme-ui';

export interface CentredSpinnerProps extends SpinnerProps {
  padding?: number | string;
}

const CentredSpinner: React.FC<CentredSpinnerProps> = ({ padding, ...props }) => (
  <Flex sx={{ flexFlow: 'column', alignItems: 'center', p: padding }}>
    <Spinner {...props} role="img" ref={null} />
  </Flex>
);

CentredSpinner.defaultProps = {
  padding: 'm'
};

export default CentredSpinner;
